import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ScrollSmoother from "gsap/ScrollSmoother";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;

    const reset = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      const smoother = ScrollSmoother.get();
      if (smoother) smoother.scrollTo(0, false);
    };

    reset();
    const frame = requestAnimationFrame(reset);
    const timeout = setTimeout(reset, 50);
    return () => {
      cancelAnimationFrame(frame);
      clearTimeout(timeout);
    };
  }, [pathname, hash]);

  return null;
}
